import {Alert, CloseButton, Text, Group, Header, Grid, Modal, Button} from "@mantine/core";
import React, {useState} from "react";
import {Defaults} from "../Constants/Constants";
import {ArrowBack, Backspace, Dashboard, Home, Logout} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";

const CustomHeader = ({showBackPress, title, backUrl}) =>{
    const [loading,setLoading] = useState(false);
    const [show,setShow] = useState(false);
    const navigation = useNavigate();
    const handleLogout =() =>{
        setLoading(true);
        localStorage.removeItem('user');
        navigation('/login');
        setShow(false);
        setLoading(false);
    }
    return  <div>
        <Header style={{backgroundColor:'#075E54',width: '100%',height: 50}} fixed position={{top: 0,left: 0}} >
        <Grid style={{paddingTop: 10,paddingLeft: 10}}>
            <Grid.Col span={10}>
                <Group position={'left'} mx={5} onClick={() => navigation(backUrl || '/')}>
                    {showBackPress ?  <ArrowBack sx={{color: 'white'}}  /> : <Home sx={{color: 'white'}} />}
                    <Text color={'white'}>{title || Defaults.AppName}</Text>
                </Group>
            </Grid.Col>
            <Grid.Col span={2}><Group position={'right'} mx={5} onClick={() => setShow(true)}>
                <Logout sx={{color: 'white'}} />
            </Group>
            </Grid.Col>
        </Grid>
    </Header>
        <Modal opened={show} onClose={() =>setShow(false)}  title="Logout">
            <Text>Are you Sure want to Logout?</Text>
            <Group mt={10} position={'right'}>
                <Button mt={5} color='gray' onClick={() =>setShow(false)}>Cancel</Button>
                <Button mt={5} color='red' onClick={() => handleLogout()} loading={loading}>Logout</Button></Group>
        </Modal>
    </div>
}
export default CustomHeader;
